import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';
import { DuLieuHeThong } from 'api';

class DropDownChonCoQuanDieuTra extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      data: this.props.data,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      let newData = [
        ...nextProps.data
      ];
      newData = newData.filter(item => {
        return item.coQuanQuanLyId != this.props.except;
      });

      this.setState({
        data: newData
      })
    }
    if (nextProps.except != this.props.except) {
      let newData = [
        ...this.props.data
      ];
      newData = newData.filter(item => {
        return item.coQuanQuanLyId != nextProps.except;
      });

      this.setState({
        data: newData
      })
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getCoQuanDieuTra.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'coQuanDieuTra',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown
        label={this.props.label}
        options={this.state.data}
        require={this.props.require}
        keyName='coQuanQuanLyId'
        valueName='ten'
        className={this.props.className}
        onChange={this.onChange.bind(this)}
        selectedValue={this.props.selectedValue}
        placeholder={this.props.placeholder}
        isValid={this.props.isValid}
        bindValidator={this}
        channel="formTaoDon"
        name={this.props.name}/>
    )
  }
}

DropDownChonCoQuanDieuTra.defaultProps = {
  isValid: false,
  require: false,
  label: 'Đơn vị chủ trì',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  except: '',
  name: '',
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.coQuanDieuTra
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonCoQuanDieuTra));



// WEBPACK FOOTER //
// ./src/components/tt-forms/DropDownChonCoQuanDieuTra.jsx